module.exports = __webpack_public_path__ + "static/assets/8ab77f5693382f9e0247a46507d2b18f.svg";